// TO TEST USE: ?promoTime=2019-05-01 09:00:00
const moment = require("moment-timezone");
import EventStatus from "./EventStatus";
//To deactivate this offer just change the dates, please don't delete this file. keep minimum two different type of banners.
class ImprezaTestDriveBannerStatus extends EventStatus {
  validModels = ["impreza"];
  get isOnNow(): boolean {
    const startDateTime: any = moment.tz("2019-10-01 09:00:00", "Australia/Melbourne");
    const endDateTime: any = moment.tz("2019-11-30 19:00:00", "Australia/Melbourne");
    return this.currentDateTime.isBetween(startDateTime, endDateTime, null, "[)");
  }
}

export default new ImprezaTestDriveBannerStatus();